module.exports = __webpack_public_path__ + "img/png.d41885b1.svg";